//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Home.Tools.MarketingTrackerNew.Settings.SalesTrackerSettings',
                {
                    url: '/SalesTrackerSettings/:LOBYear',
                    component: 'salesTrackerSettingsComponent',
                    PageTitle: "Sales Tracker Settings | Marketing Tracker",
                });
        }
    ]);

    app
        .component('salesTrackerSettingsComponent', {
            templateUrl: 'App/Tools/MarketingTrackerNew/Settings/SalesTrackerSettings/SalesTrackerSettings.template.html',
            controller: 'SalesTrackerSettingsController',
            bindings: {
                user: "<",
            }
        })
        .controller('SalesTrackerSettingsController', [
            "_", "marketingTrackerSalesTrackerSettingsApi", "$q", "$state", "$timeout", "figToaster","featureToggleService",
            function (_, marketingTrackerSalesTrackerSettingsApi, $q, $state, $timeout, figToaster, featureToggleService) {
                const $ctrl = this;

                ng.extend($ctrl,
                    {
                        ui: {
                            isAdmin: false,
                            loadingColumns: false,
                            loadingLOB: false
                        },
                        columns: {
                            Advisors: {
                                Name: "Advisor",
                                Icon: "fig-human",
                                Value: "Name",
                                List: [],
                                Order: "Order"
                            },
                            Sources: {
                                Name: "Source",
                                Icon: "fig-speaker",
                                Value: "SourceName",
                                List: []
                            },
                            Statuses: {
                                Name: "Opportunity Status",
                                PluralName: "Opportunity Statuses",
                                Icon: "fig-account-multiple",
                                Value: "StatusName",
                                List: []
                            }
                        },
                        Lobs: [],
                        years: [],
                        newLOB: {}
                    });
                $ctrl.modifiedSort = function (item) {
                    if (item.IsStandardStatus) {
                        return -1;
                    } return item.Order || item.StatusName || item.SourceName;
                };
                $ctrl.resetDate = function (timeFrame) {
                    $ctrl.endDate = !!timeFrame
                        ? moment().set({ 'year': timeFrame }).endOf('year').format()
                        : moment().endOf('year').format();
                    $ctrl.startDate = !!timeFrame
                        ? moment().set({ 'year': timeFrame }).startOf('year').format()
                        : moment().startOf('year').format();

                    return marketingTrackerSalesTrackerSettingsApi.getLinesOfBusinessDetailsByTimeFrame($ctrl.startDate, $ctrl.endDate)
                        .then(function (response) {
                            $ctrl.LOBDetails = response;
                            $ctrl.Lobs.forEach(function (lob) {
                                var lobDetails = $ctrl.LOBDetails.find(function (x) { return x.LineOfBusinessId == lob.Id });
                                lob.LOBDetails = !!lobDetails ? lobDetails : {};
                                lob.LOBDetails.RoiMultiplier = !!lob.LOBDetails.RoiMultiplier ? lob.LOBDetails.RoiMultiplier * 100 : null;
                            });
                        })
                        .catch(function (error) {
                            console.log(error.data);
                        });
                }
                $ctrl.itemToggleActive = function (item, items, valueType) {
                    const updatedItem = ng.copy(item);
                    const promises = [];
                    updatedItem.IsActive = !updatedItem.IsActive;
                    switch (valueType) {
                        case "Name":
                            promises.push(marketingTrackerSalesTrackerSettingsApi.updateAdvisorActiveStatus(updatedItem));
                            break;
                        case "SourceName":
                            promises.push(marketingTrackerSalesTrackerSettingsApi.updateSourceActiveStatus(updatedItem));
                            break;
                        case "StatusName":
                            promises.push(marketingTrackerSalesTrackerSettingsApi.updateStatusActiveStatus(updatedItem));
                            break;
                        case "LineOfBusinessName":
                            promises.push(marketingTrackerSalesTrackerSettingsApi.updateLineOfBusinesActiveStatus(updatedItem));
                            break;
                        default:
                            break;
                    };
                    $q.all(promises)
                        .then(function (response) {
                            item = ng.copy(response[0]);
                            console.log(item)                            
                        })
                        .catch(function (error) {
                            console.log(error.data);                           
                            
                            var message = error.data,
                                toastClass = "is-error";

                            figToaster.showSimple(message, "top", toastClass);

                             //error, so revert isActive status back
                            updatedItem.IsActive = !updatedItem.IsActive;
                        })
                        .finally(function () {
                            if (!updatedItem.IsActive) {
                                items = _.remove(items, { Id: updatedItem.Id });
                            }
                        });
                };

                $ctrl.hasCompletedAllLOBDetails = function (details) {
                    if ((!!details.GoalValue || details.GoalValue >= 0) && (!!details.Multiplier || details.Multiplier >= 0) && (!!details.RoiMultiplier || details.RoiMultiplier >= 0)) {
                        return true;
                    } else {
                        return false;
                    }
                };

                $ctrl.increaseOrder = function (item, items) {
                    // verify the order can be increased
                    var maxOrder = _.max(_.map(items, function (a) { return a.Order; }));
                    if (item.Order < maxOrder) {
                        items = _.orderBy(items, ['Order']);
                        //find the first item larger than the item to swap orders
                        // this assumes the items are ordered left to right in ascending order
                        var swapItem = _.find(items, function (i) { return i.Order > item.Order; });
                        var tempOrder = swapItem.Order;
                        swapItem.Order = item.Order;
                        item.Order = tempOrder;
                        items = _.orderBy(items, ['Order']);
                        marketingTrackerSalesTrackerSettingsApi.updateAdvisorsOrders(items);
                    }
                };

                $ctrl.decreaseOrder = function (item, items) {
                    // verify the order can be decreased
                    var minOrder = _.min(_.map(items, function (a) { return a.Order; }));
                    if (item.Order > minOrder) {
                        items = _.orderBy(items, ['Order']);
                        //find the first item smaller than the item to swap orders
                        // this assumes the items are ordered left to right in ascending order
                        var swapItem = _.findLast(items, function (i) { return i.Order < item.Order; });
                        var tempOrder = swapItem.Order;
                        swapItem.Order = item.Order;
                        item.Order = tempOrder;
                        items = _.orderBy(items, ['Order']);
                        marketingTrackerSalesTrackerSettingsApi.updateAdvisorsOrders(items);
                    }
                };

                $ctrl.updateItem = function (item, valueType) {
                    var updatedItem = ng.copy(item);
                    const promises = [];
                    if (updatedItem.Id) {
                        switch (valueType) {
                            case "Name":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.updateAdvisor(updatedItem));
                                break;
                            case "SourceName":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.updateSource(updatedItem));
                                break;
                            case "StatusName":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.updateStatus(updatedItem));
                                break;
                            case "LineOfBusinessName":
                                if (!!updatedItem.Id) {
                                    promises.push(marketingTrackerSalesTrackerSettingsApi.updateLineOfBusinessName(updatedItem))
                                } else {
                                    $ctrl.addItem(updatedItem, $ctrl.Lobs, 'LineOfBusinessName');
                                    return
                                } break;
                            case "LineOfBusinessDetails":
                                if (!!updatedItem.LOBDetails.Id) {
                                    updatedItem.LOBDetails.StartDate = $ctrl.startDate;
                                    updatedItem.LOBDetails.EndDate = $ctrl.endDate;
                                    updatedItem.LOBDetails.RoiMultiplier = updatedItem.LOBDetails.RoiMultiplier / 100;
                                    promises.push(marketingTrackerSalesTrackerSettingsApi.updateLineOfBusinessDetails(updatedItem.LOBDetails));
                                } else {
                                    if (!!updatedItem.Id) {
                                        updatedItem.LOBDetails.LineOfBusinessId = updatedItem.Id;
                                        updatedItem.LOBDetails.StartDate = $ctrl.startDate;
                                        updatedItem.LOBDetails.EndDate = $ctrl.endDate;
                                        updatedItem.LOBDetails.RoiMultiplier = updatedItem.LOBDetails.RoiMultiplier ? updatedItem.LOBDetails.RoiMultiplier / 100 : 0;
                                        updatedItem.LOBDetails.Multiplier = updatedItem.LOBDetails.Multiplier ? updatedItem.LOBDetails.Multiplier : 1;
                                        promises.push(marketingTrackerSalesTrackerSettingsApi.createLineOfBusinessDetails(updatedItem.LOBDetails));
                                    }
                                    break;
                                } break;
                            case "StatusParentStatus":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.updateStatusParentStatus(updatedItem));
                                $ctrl.StatusesGroupedByParents = _.groupBy($ctrl.columns.Statuses.List, 'ParentStatusId');
                                break;
                            default:
                                break;
                        };
                        $q.all(promises)
                            .then(function (response) {
                                if (response.length > 0) {
                                    if (valueType === "LineOfBusinessDetails") {
                                        item.LOBDetails = response[0]
                                        if (item.LOBDetails && item.LOBDetails.RoiMultiplier) item.LOBDetails.RoiMultiplier = response[0].RoiMultiplier * 100;
                                    } else {
                                        item = response[0];
                                    }
                                }                              
                                return updatedItem;
                            })
                            .catch(function (error) {
                                console.log(error.data);
                            })
                            .finally(function () {
                            });
                    }
                };
                $ctrl.addItem = function (item, items, valueType) {
                    const newItem = ng.copy(item);
                    const promises = [];
                    if (newItem) {
                        newItem.IsActive = true;
                        switch (valueType) {
                            case "Name":
                                newItem.Order = $ctrl.nextAdvisorOrder;
                                promises.push(marketingTrackerSalesTrackerSettingsApi.createAdvisor(newItem));
                                break;
                            case "SourceName":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.createSource(newItem));
                                break;
                            case "StatusName":
                                promises.push(marketingTrackerSalesTrackerSettingsApi.createStatus(newItem));
                                break;
                            case "LineOfBusinessName":
                                if (!!newItem.Id) {
                                    $ctrl.updateItem(item, "LineOfBusinessName");
                                    return
                                } else {
                                    if (newItem.LOBDetails && newItem.LOBDetails.RoiMultiplier) newItem.LOBDetails.RoiMultiplier = newItem.LOBDetails.RoiMultiplier / 100;
                                    promises.push(marketingTrackerSalesTrackerSettingsApi.createLineOfBusiness(newItem));
                                } break;
                            default:
                                newItem.New = {};
                                break;
                        };
                        $q.all(promises)
                            .then(function (response) {
                                newItem.Id = response[0].Id;
                                if (newItem.LineOfBusinessName) {
                                    newItem.LOBDetails = ng.copy($ctrl.newLOB.LOBDetails);
                                    newItem.LOBDetails.LineOfBusinessId = newItem.Id;
                                    newItem.LOBDetails.StartDate = $ctrl.startDate;
                                    newItem.LOBDetails.EndDate = $ctrl.endDate;
                                    newItem.LOBDetails.RoiMultiplier = newItem.LOBDetails.RoiMultiplier / 100;
                                    marketingTrackerSalesTrackerSettingsApi.createLineOfBusinessDetails(newItem.LOBDetails)
                                        .then(function (response) {
                                            newItem.LOBDetails = response;
                                            if (response && response.RoiMultiplier) newItem.LOBDetails.RoiMultiplier = response.RoiMultiplier * 100;
                                        })
                                        .finally(function () { items.push(newItem); });
                                }
                                else {
                                    items.push(newItem);
                                    if (valueType === "Name") {
                                        $ctrl.nextAdvisorOrder = _.max(_.map(items, function (a) { return a.Order; })) + 1;
                                    }
                                }
                                return newItem.Id;

                            })
                            .catch(function (error) {
                                console.log(error.data);
                            })
                            .finally(function () {
                                item.Name = null;
                                item.SourceName = null;
                                item.StatusName = null;
                                item.LineOfBusinessName = null;
                                item.LOBDetails = {};
                            });
                    }
                };
                $ctrl.goToYear = function () {
                    var params = ng.copy($state.params);
                    params.LOBYear = $ctrl.lobYear;
                    var currentState = $state.current.name;
                    $state.go(currentState, params);
                }

                $ctrl.$onInit = function () {
                    $ctrl.toggleFeature = featureToggleService.checkEnv();
                    $ctrl.currentYear = (new Date()).getUTCFullYear();
                    for (var i = 2015; i <= $ctrl.currentYear; i++) {
                        $ctrl.years.push(i);
                    }
                    $ctrl.lobYear = parseInt($state.params.LOBYear);
                    $ctrl.loadingColumns = true;
                    $ctrl.resetDate($ctrl.lobYear);
                    $ctrl.newLOB = {
                        LineOfBusinessName: '',
                        LineOfBusinessId: null,
                        LOBDetails: {
                            LineOfBusiness: {},
                            StartDate: $ctrl.startDate,
                            EndDate: $ctrl.endDate }
                        
                    };
                    const promises = [
                        marketingTrackerSalesTrackerSettingsApi.getAdvisors(),
                        marketingTrackerSalesTrackerSettingsApi.getSources(),
                        marketingTrackerSalesTrackerSettingsApi.getStatuses(),
                        marketingTrackerSalesTrackerSettingsApi.getLinesOfBusiness(),
                        marketingTrackerSalesTrackerSettingsApi.getLinesOfBusinessDetailsByTimeFrame($ctrl.startDate, $ctrl.endDate)
                    ];

                    $q.all(promises)
                        .then(function (responses) {
                            $ctrl.columns.Advisors.List = responses[0] ? responses[0] : [];
                            if (_.some($ctrl.columns.Advisors.List, function (a) { return a.Order < 1; })) {
                                // has 0 ordering, need to fix those
                                var maxOrder = _.max(_.map($ctrl.columns.Advisors.List, function (a) { return a.Order; }));
                                var items = _.map($ctrl.columns.Advisors.List, function (a) {
                                    var advCopy = {};
                                    ng.copy(a, advCopy);
                                    if (a.Order < 1) {
                                        advCopy.Order = ++maxOrder;
                                    }
                                    return advCopy;
                                });
                                marketingTrackerSalesTrackerSettingsApi.updateAdvisorsOrders(items).then(function (response) {
                                    $ctrl.columns.Advisors.List = items;
                                    $ctrl.nextAdvisorOrder = _.max(_.map($ctrl.columns.Advisors.List, function (a) { return a.Order; })) + 1;
                                });
                            } else {
                                $ctrl.nextAdvisorOrder = _.max(_.map($ctrl.columns.Advisors.List, function (a) { return a.Order; })) + 1;
                            }
                            $ctrl.columns.Sources.List = responses[1] ? responses[1] : [];
                            $ctrl.columns.Statuses.List = responses[2] ? responses[2] : [];
                            $ctrl.Lobs = !!responses[3] ? responses[3] : [];
                            $ctrl.LOBDetails = !!responses[4] ? responses[4] : [];

                            $ctrl.Lobs.forEach(function (lob) {
                                var lobDetails = $ctrl.LOBDetails.find(function (x) { return x.LineOfBusinessId == lob.Id });
                                lob.LOBDetails = !!lobDetails ? lobDetails : {};
                                if (lobDetails && lobDetails.RoiMultiplier) lob.LOBDetails.RoiMultiplier = lobDetails.RoiMultiplier * 100;                                
                            });

                            $ctrl.StandardStatuses = [
                                {
                                    Id: null,
                                    StatusName: "",
                                }
                            ].concat($ctrl.columns.Statuses.List.filter(function (s) {
                                return s.IsStandardStatus;
                            }));

                            $ctrl.StatusesGroupedByParents = _.groupBy($ctrl.columns.Statuses.List, 'ParentStatusId');
                        })
                        .finally(function () {
                            $ctrl.loadingColumns = false;
                        });
                };
            }]);
})(window.angular, window.app);